import AnalyticsBoard from '@/components/payroll_tsx/AnalyticsBoard/AnalyticsBoard';
import EmployeeWeekly from '@/components/payroll_tsx/EmployeeWeekly/EmployeeWeekly';
import SalonWeekly from '@/components/payroll_tsx/SalonWeekly/SalonWeekly';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { useState } from 'react';

// Main Payroll Page Component with basic shadcn tabs layout
const Payroll = () => {
  const [selectedDate, setSelectedDate] = useState<Date>(new Date());
  const [activeTab, setActiveTab] = useState('salon');

  return (
    <div className="flex-1 space-y-4 px-1 py-4">
      <div className="flex items-center justify-between space-y-2">
        <h4 className="text-2xl font-bold tracking-tight">Payroll Management</h4>
      </div>

      <Tabs value={activeTab} onValueChange={setActiveTab} className="space-y-4">
        <TabsList>
          <TabsTrigger value="salon">Salon Weekly</TabsTrigger>
          <TabsTrigger value="employee">Employee Weekly</TabsTrigger>
          <TabsTrigger value="analytics">Analytics Board</TabsTrigger>
        </TabsList>

        <TabsContent value="salon" className="space-y-4 ">
          <SalonWeekly selectedDate={selectedDate} onDateChange={setSelectedDate} />
        </TabsContent>

        <TabsContent value="employee" className="space-y-4">
          <EmployeeWeekly selectedDate={selectedDate} onDateChange={setSelectedDate} />
        </TabsContent>

        <TabsContent value="analytics" className="space-y-4">
          {activeTab === 'analytics' && <AnalyticsBoard />}
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default Payroll;
